import { AccountInfoType } from './types';
import { AgentLinxStatus } from './enum';

type AccountFile = Pick<AccountInfoType, 'accountNumber'>;
type ClosedAccountFiles = {
  files: AccountFile[];
};
type QueueChange = 'enqueue' | 'dequeue';
type BookOrderDisabledState = {
  hasBookOrderActivityRight: boolean;
  invalidRowSelected: boolean;
  hasSystemCancelledOrderAccount: boolean;
  isAllOrderAccountInfoPending: boolean;
};

export const SYSTEM_CANCELLED_BOOK_TOOLTIP = 'One or more accounts are in a System Cancelled status.';

export const getOrderAccountNumbers = (openFiles: AccountFile[], closedFiles: ClosedAccountFiles[]): number[] => {
  const accountNumbers = [
    ...openFiles.map(({ accountNumber }) => accountNumber),
    ...closedFiles.flatMap(({ files }) => files.map(({ accountNumber }) => accountNumber)),
  ];

  return Array.from(new Set(accountNumbers));
};

export const getQueueGuardUpdate = <T extends AccountFile>(
  openFiles: T[],
  changedFiles: T[],
  closedFiles: ClosedAccountFiles[],
  change: QueueChange,
): { openFiles: T[]; accountNumbers: number[] } => {
  const updatedOpenFiles =
    change === 'enqueue' ? [...openFiles, ...changedFiles] : openFiles.filter((file) => !changedFiles.includes(file));

  return {
    openFiles: updatedOpenFiles,
    accountNumbers: getOrderAccountNumbers(updatedOpenFiles, closedFiles),
  };
};

export const hasSystemCancelledAccount = (accounts: Array<Pick<AccountInfoType, 'agentLinxStatus'>>): boolean =>
  accounts.some(
    ({ agentLinxStatus }) => agentLinxStatus?.trim().toLowerCase() === AgentLinxStatus.SystemCancelled.toLowerCase(),
  );

export const isBookOrderDisabled = ({
  hasBookOrderActivityRight,
  invalidRowSelected,
  hasSystemCancelledOrderAccount,
  isAllOrderAccountInfoPending,
}: BookOrderDisabledState): boolean =>
  !hasBookOrderActivityRight || invalidRowSelected || hasSystemCancelledOrderAccount || isAllOrderAccountInfoPending;
